// extracted by mini-css-extract-plugin
module.exports = {"root":"Item_root__Ju2IJ","preview":"Item_preview__1EbjZ","filesize":"Item_filesize__1wlp5","listItem":"Item_listItem__9XYc_","icon":"Item_icon__2B0eN"};